export default {
  'meta': {
    'langName': 'BULGARIAN',
    'lang': 'Български'
  },
  'title': 'ИЗТЕГЛЯНЕ НА ПРОДУКТ – БАСКЕТБОЛЕН КОШ B900 BOX NBA TARMAK',
  'description': 'Установихме риск от вертикално падане на стълба на нашия баскетболен кош B900, ако се използва без манивелата си и бъде манипулиран. С оглед на Вашата безопасност преустановете незабавно използването на коша без монтираната манивела за регулиране на височината. Баскетболният кош може да бъде обезопасен чрез проста процедура по смяна на манивелата и с помощта на ремонтен комплект, който ще Ви бъде доставен безплатно. Специализираният уебсайт за това изтегляне е в процес на създаване. Той ще Ви води стъпка по стъпка в извършването на процедурата.\nЩе Ви уведомим веднага щом сайтът бъде достъпен (през юли).',
  'status': 'Translation validated by COUNTRY'
} as const
